import React from 'react';
import { Field } from 'formik';
import './form-elements.scss';
export default ({ name, handleSelect, onChange, label, disabled, checked }) => (
  <Field name={name}>
    {({ field, form }) => (
      <div className={name === 'authorize' ? 'checkbox-fieldAuth' : 'checkbox-field'}>
        <label className='checkbox-container'>
          <input
            id={name}
            name={name}
            type='checkbox'
            checked={checked ?? (form.values[name] ? form.values[name] : false)}
            disabled={disabled}
            onClick={(event) => {
              // form.setFieldValue(name, event.target.checked);
              if (handleSelect) {
                handleSelect(form.values[name], label, event.target.checked, name)
              }

              if (onChange) {
                form.setFieldValue(name, event.target.checked);
                onChange(event.target.checked, label)
              }
            }}
            {...field}
          />
          <span className={disabled ? 'checkMarkDisable' : 'checkMark'}></span>
          {/* <span className={'checkMark'}></span> */}
          {label}
        </label>
      </div>
    )}
  </Field>
);
